class PickupAvailability extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute('available')) return;

    this.errorHtml =
      this.querySelector(
        'template'
      ).content.firstElementChild.cloneNode(true);
    this.onClickRefreshList = this.onClickRefreshList.bind(this);
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const rootUrl = !this.dataset.rootUrl.endsWith('/')
      ? `${this.dataset.rootUrl}/`
      : this.dataset.rootUrl;

    const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

    fetch(variantSectionUrl)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML);
      })
      .catch(e => {
        const button = this.querySelector('button');

        if (button)
          button.removeEventListener(
            'click',
            this.onClickRefreshList
          );

        this.renderError();
      });
  }

  onClickRefreshList(event) {
    this.fetchAvailability(this.dataset.variantId);
  }

  renderError() {
    this.innerHTML = '';
    this.appendChild(this.errorHtml);
    this.querySelector('button').addEventListener(
      'click',
      this.onClickRefreshList
    );
  }

  renderPreview(sectionInnerHTML) {
    const preview = sectionInnerHTML.querySelector(
      'pickup-availability-preview'
    );

    if (!preview) {
      this.innerHTML = '';
      this.removeAttribute('available');

      return;
    }

    this.renderStoreInfoImage(preview);

    this.innerHTML = preview.outerHTML;
    this.setAttribute('available', '');
  }

  renderStoreInfoImage(preview) {
    if (!this.dataset.storeInfoImage) return;

    const drawerRow = preview.querySelector('.drawer__row');
    if (!drawerRow) return;

    const imageWrapper = document.createElement('div');
    imageWrapper.className = 'pickup-availability-store-image';

    const image = document.createElement('img');
    image.src = this.dataset.storeInfoImage;
    image.alt = this.dataset.storeInfoImageAlt || '';
    image.loading = 'lazy';

    imageWrapper.appendChild(image);
    const title = drawerRow.querySelector('.drawer__title');

    drawerRow.insertBefore(
      imageWrapper,
      title ? title.nextElementSibling : drawerRow.firstChild
    );
  }
}

customElements.define('pickup-availability', PickupAvailability);
